<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Arrow_down"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path
      id="Path_8017"
      data-name="Path 8017"
      d="M8,10l3,3,3-3"
      transform="translate(-2 -2.5)"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8018" data-name="Path 8018" d="M0,0H18V18H0Z" fill="none" />
  </svg>
</template>
